import React, { useState, useEffect, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiChevronLeft, FiChevronRight } = FiIcons;

const images = [
  "https://media-manager-c.questera.ai/greta-media/22aa865ee86cefe9c860e7d06bbd1b00a5df93e170adbe6f023ba9046dde80b0080d4241ae2bf2b28b7ae4a2b0aac3e9/images/aW1hZ2UvanBlZw==/3ed8542d2eec97c234d4dd23e4311f1b.jpg",
  "https://vecindapp-prod.s3.amazonaws.com/clients/vecindapp/edificio-manzana-3-propiedad-horizontal/edificio-manzana-3-propiedad-horizontal/facility/Piscina/facilities/5faK7uygNNrXdQh9AEQ1KjJ4UihTp8M24mIv2uxW.jpg",
  "https://media-manager-c.questera.ai/greta-media/22aa865ee86cefe9c860e7d06bbd1b00a5df93e170adbe6f023ba9046dde80b0080d4241ae2bf2b28b7ae4a2b0aac3e9/images/aW1hZ2UvanBlZw==/ffd3895504c76b1555b3f75c620b1fc7.jpg",
  "https://media-manager-c.questera.ai/greta-media/22aa865ee86cefe9c860e7d06bbd1b00a5df93e170adbe6f023ba9046dde80b0080d4241ae2bf2b28b7ae4a2b0aac3e9/images/aW1hZ2UvanBlZw==/ed4b550f5ddd2f41d42bec14cc3d3de8.jpg",
  "https://media-manager-c.questera.ai/greta-media/22aa865ee86cefe9c860e7d06bbd1b00a5df93e170adbe6f023ba9046dde80b0080d4241ae2bf2b28b7ae4a2b0aac3e9/images/aW1hZ2UvanBlZw==/3879bd5ffa76e88e28783d608968ef4f.jpg",
  "https://media-manager-c.questera.ai/greta-media/22aa865ee86cefe9c860e7d06bbd1b00a5df93e170adbe6f023ba9046dde80b0080d4241ae2bf2b28b7ae4a2b0aac3e9/images/aW1hZ2UvanBlZw==/c3b73636fb13cfe3a8ced123c5324065.jpg",
  "https://media-manager-c.questera.ai/greta-media/22aa865ee86cefe9c860e7d06bbd1b00a5df93e170adbe6f023ba9046dde80b0080d4241ae2bf2b28b7ae4a2b0aac3e9/images/aW1hZ2UvanBlZw==/bbf04c2e4c4fb717929f00bdc4195364.jpg",
  "https://media-manager-c.questera.ai/greta-media/22aa865ee86cefe9c860e7d06bbd1b00a5df93e170adbe6f023ba9046dde80b0080d4241ae2bf2b28b7ae4a2b0aac3e9/images/aW1hZ2UvanBlZw==/b49551f29e8f111f86936627a83a1ef5.jpg"
];

export default function ApartmentCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);

  const nextSlide = useCallback(() => {
    setDirection(1);
    setCurrentIndex((prev) => (prev + 1) % images.length);
  }, []);

  const prevSlide = useCallback(() => {
    setDirection(-1);
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(nextSlide, 4000);
    return () => clearInterval(timer);
  }, [nextSlide]);

  const variants = {
    enter: (direction) => ({
      x: direction > 0 ? 1000 : -1000,
      opacity: 0
    }),
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1
    },
    exit: (direction) => ({
      zIndex: 0,
      x: direction < 0 ? 1000 : -1000,
      opacity: 0
    })
  };

  return (
    <div className="relative w-full h-[280px] md:h-[400px] overflow-hidden rounded-3xl shadow-lg mb-8 bg-gray-100">
      <AnimatePresence initial={false} custom={direction}>
        <motion.img
          key={currentIndex}
          src={images[currentIndex]}
          custom={direction}
          variants={variants}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{
            x: { type: "spring", stiffness: 300, damping: 30 },
            opacity: { duration: 0.2 }
          }}
          className="absolute inset-0 w-full h-full object-cover"
          alt={`Apartment view ${currentIndex + 1}`}
        />
      </AnimatePresence>

      <button
        onClick={prevSlide}
        className="absolute left-4 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-white/80 backdrop-blur-sm text-emerald-800 flex items-center justify-center hover:bg-white transition-colors shadow-md"
      >
        <SafeIcon icon={FiChevronLeft} className="text-xl" />
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-4 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-white/80 backdrop-blur-sm text-emerald-800 flex items-center justify-center hover:bg-white transition-colors shadow-md"
      >
        <SafeIcon icon={FiChevronRight} className="text-xl" />
      </button>

      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-10 flex gap-2">
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => {
              setDirection(index > currentIndex ? 1 : -1);
              setCurrentIndex(index);
            }}
            className={`w-2.5 h-2.5 rounded-full transition-all ${
              currentIndex === index 
                ? 'bg-emerald-600 w-6' 
                : 'bg-white/60 hover:bg-white'
            }`}
          />
        ))}
      </div>
    </div>
  );
}